import { getDateTime } from "../../services/CheckMeProBlePackages";
var PACKAGESIZE = 10;
export function parseTemperatureItem(bytes) {
    var start = 0;
    var returnList = new Array();
    for (var k = 0; k < bytes.length - 8; k++) {
        if (start + PACKAGESIZE >= bytes.length)
            break;
        var user = {};
        returnList.push(user);
        start = k * PACKAGESIZE;
        user.date = getDateTime(bytes, start);
        user.way = bytes[start + 7];
        user.tmp = (bytes[start + 9] & 0xff) + ((bytes[start + 9] & 0xff) << 8);
    }
    return returnList;
}
